import AnnualSummaryGrid from "./AnnualSummaryGrid";

const AnnualSummaryTab = () => {
    return (
        <div className="container-fluid">
            <AnnualSummaryGrid gridHeight="70vh"/>
        </div>
    );
};

export default AnnualSummaryTab;
